export const LOG_URLS = {
  GET_ADMIN_LOGS: '/admin-logs',
  GET_LOG_BY_USER_ID: '/admin-logs/logs',
  GET_LOG_BY_ROLE_ID: '/admin-logs/logs-roles',
  GET_LOG_BY_WITH_INCOME_CONFIGURE_ID:
    '/admin-logs/logs-with-income-configuration',
  GET_LOG_BY_WITHOUT_INCOME_CONFIGURE_ID:
    '/admin-logs/logs-without-income-configuration',
  GET_LOG_BY_PRODUCT_ID: '/admin-logs/logs-product',
  GET_LOG_BY_ADMIN_LEVEL_ID: '/admin-logs/logs-admin-level'
};
